export default __webpack_public_path__ + "static/ayana_lake_client-0b791c193cc66f0ece434b9793675773.png";